import { Injectable } from '@angular/core';
import {Status} from '../interfaces/status';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  public TRACK_ID:string = "tracks";
  public TRACK_IMAGE:string = "tracks_images";
  public DATA_STATUS:Status[];


  constructor() {
     this.DATA_STATUS = [
       {id:'_', name:' --- '},
       {id: '_START', name: 'REGISTRADO' },
       { id: '_PROCESS', name: 'EN RUTA' },
       { id: '_COMPLETED', name: 'ENTREGADO ' }
     ]

   }

}
